import React, { useEffect, useState } from "react";
import {  Col,  Form,  Input,  Modal,  Switch,  Row,  theme,} from "antd";
import { POST, PATCH } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";

export default function FactoryBankAccountModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessage, setErrorMessage] = useState(null);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (target) {
      form.setFieldsValue(target);
      setIsActive(target.is_active ?? false);
    } else {
      form.resetFields();
      form.setFieldValue("is_active", true)
      setIsActive(true);
    }
  }, [open, target]);

  const handleSwitchChange = (checked) => {
    setIsActive(checked);
  };

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessage(null);
    try {
      const data = await form.validateFields();
      data.is_active = isActive;
      if (target?.id) {
        await PATCH(`${URL_SETTING.BANK_ACCOUNT}${target.id}/`, data);
      } else {
        await POST(URL_SETTING.BANK_ACCOUNT, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessage(error.errorMessage);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessage(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขบัญชีธนาคาร" : " เพิ่มบัญชีธนาคาร"}
      width={550}
      onOk={handleOK}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessage} />

      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="สถานะการใช้งาน" layout="horizontal">
              <Row align="middle" gutter={8}>
                <Col>
                  <Form.Item name="is_active" valuePropName="checked" noStyle>
                    <Switch onChange={handleSwitchChange} />
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="ชื่อบัญชี"
              name="account_name"
              rules={[{ required: true, message: "กรุณากรอกชื่อบัญชี" }]}
            >
              <Input placeholder="กรอกชื่อลูกค้า" allowClear />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="ชื่อธนาคาร"
              name="bank_name"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Input placeholder="ชื่อธนาคาร"/>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="เลขที่บัญชี"
              name="account_no"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Input placeholder="เลขที่บัญชี"/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
